import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { AuthService } from "@auth0/auth0-angular";
import { catchError, filter, map, of, switchMap, take } from "rxjs";
import { SessionService } from "../services/session.service";

export const guestGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const session = inject(SessionService);

  return auth.isLoading$.pipe(
    filter((loading) => !loading),
    take(1),
    switchMap(() => auth.isAuthenticated$),
    take(1),
    switchMap((isAuthenticated) => {
      if (!isAuthenticated) return of(true);

      return session.loadCurrentUser().pipe(
        take(1),
        map((user) => {
          const hasBusiness = (user?.businessUsers?.length ?? 0) > 0;
          if (hasBusiness) {
            void router.navigate(["/select-business"]);
            return false;
          }
          return true;
        }),
        catchError(() => of(true))
      );
    })
  );
};
